import { motion } from "framer-motion";
import CandidateForm from "@/components/CandidateForm";

export default function JoinNetwork() {
  return (
    <section
      id="network"
      data-testid="network-section"
      className="relative bg-[#0E2750] py-24 md:py-36 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5">
            <motion.span
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="font-mono-eyebrow text-[#C9A876]"
            >
              ◆ Join the Network
            </motion.span>
            <motion.h2
              data-testid="network-heading"
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="mt-5 font-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.05] text-white"
            >
              For senior operators considering their{" "}
              <span className="font-serif-accent text-[#C9A876]">next</span> chapter.
            </motion.h2>
            <p className="mt-6 text-slate-400 leading-relaxed">
              Join a trusted senior leadership network across the UK founder
              ecosystem. We're building long-term relationships with
              exceptional operators — for future confidential mandates,
              strategic introductions and market conversations.
            </p>

            <ul className="mt-10 space-y-4 text-sm text-slate-300">
              {[
                "Relationship-first executive search built for long-term value creation.",
                "Confidential by default — your details are never shared without permission.",
                "Reviewed personally by the founder.",
              ].map((t) => (
                <li key={t} className="flex items-start gap-3">
                  <span className="mt-2 block h-px w-5 bg-[#C9A876]" />
                  <span>{t}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-7">
            <div className="border border-white/10 bg-[#15315F]/60 backdrop-blur-sm p-6 md:p-10">
              <CandidateForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
